import Vue from 'vue'
import Vuex from 'vuex'
import * as actions from './action'
import mutations from './mutations'
Vue.use(Vuex)

const state = {
  RefreshToken: '',
  AccessToken: '',
  Profile: {},
  Authen: false,
  StatusBusiness: false,
  Business: {},
  AllBusiness: [],
  DataPolicy: [],
  DataPetition: [],
  DataConsent: [],
  DataSmtpEmail: [],
  DataConsentGroup: [],
  DataGeneralConsent: [],
  DataGroupConsent: [],
  DataGroupConsentOnechat: [],
  DataGroupConsentOnechatPath: [],
  DataGeneralDashboard: [],
  DataGroupDashboard: [],
  DataCheckRole: [],
  DataGroupOneChatSearch: [],
  DataCheckUser: [],
  RoleAccount: '',
  DataAnnounce: '',
  DataAccount: [],
  DataAllRoleAccess: [],
  MenuToolbarDefault: [],
  DataBotOnePlatform: {},
  DataUpdateBot: {},
  LoadingLogin: false,
  MenuToolbar: [
    {
      RoleAccess: [],
      ShowSetting: false,
      active: false,
      children: [
        {
          RoleAccess: [],
          ShowSetting: false,
          active: false,
          children: [],
          description: 'ภาพรวมการใช้งาน',
          disable: false,
          group: false,
          icon: '',
          list: [],
          no: 1,
          text: 'Toolbar.ConsentOverview',
          to: '/dashboard-user'
        },
        {
          RoleAccess: [],
          ShowSetting: false,
          active: false,
          children: [],
          description: 'รายการความยินยอม',
          disable: false,
          group: false,
          icon: '',
          list: [],
          no: 2,
          text: 'Toolbar.consentlist',
          to: '/consent-list'
        }
      ],
      description: 'ตรวจสอบสิทธิตนเอง',
      disable: false,
      group: true,
      icon: 'mdi-account',
      no: 1,
      text: 'Toolbar.myRight',
      to: '/profile'
    },
    {
      RoleAccess: ['DPC', 'DPO'],
      ShowSetting: true,
      active: false,
      children: [
        {
          RoleAccess: [],
          ShowSetting: true,
          active: false,
          children: [],
          description: 'คำร้องที่ถูกส่งถึง',
          disable: false,
          group: false,
          icon: '',
          list: [],
          no: 1,
          text: 'Toolbar.petition',
          to: '/petition-index'
        },
        {
          RoleAccess: [],
          ShowSetting: true,
          active: false,
          children: [],
          description: 'ข้อมูลการใช้งาน',
          disable: false,
          group: false,
          icon: '',
          list: [],
          no: 2,
          text: 'Toolbar.usage',
          to: '/dashboard'
        },
        {
          RoleAccess: [],
          ShowSetting: true,
          active: false,
          children: [],
          description: 'ค้นหาความยินยอม',
          disable: false,
          group: false,
          icon: '',
          list: [],
          no: 3,
          text: 'Toolbar.SearchConsent',
          to: '/search-consent-index'
        },
        {
          RoleAccess: [],
          ShowSetting: true,
          active: false,
          description: 'ความยินยอม',
          disable: false,
          group: true,
          icon: '',
          list: [
            {
              RoleAccess: [],
              ShowSetting: true,
              active: false,
              children: [],
              description: 'สร้างนโยบาย',
              disable: false,
              group: false,
              icon: '',
              no: 1,
              text: 'Toolbar.policy',
              to: '/policy-index'
            },
            {
              RoleAccess: [],
              ShowSetting: true,
              active: false,
              description: 'สร้างความยินยอม',
              disable: false,
              group: false,
              icon: '',
              list: [],
              no: 2,
              text: 'Toolbar.consentform',
              to: '/consent-index'
            },
            {
              RoleAccess: [],
              ShowSetting: true,
              active: false,
              description: 'จัดกลุ่มความยินยอม',
              disable: false,
              group: false,
              icon: '',
              list: [],
              no: 3,
              text: 'Toolbar.mcg',
              to: '/consent-management-group-index'
            }
          ],
          no: 4,
          text: 'Toolbar.consent',
          to: '/consent-index'
        },
        {
          RoleAccess: [],
          ShowSetting: true,
          active: false,
          description: 'ขอความยินยอม',
          disable: false,
          group: true,
          icon: '',
          list: [
            {
              RoleAccess: [],
              ShowSetting: true,
              active: false,
              description: 'OnePlatform',
              disable: false,
              group: false,
              icon: '',
              list: [],
              no: 1,
              text: 'OnePlatform',
              to: '/consent-create-oneplatform'
            },
            {
              RoleAccess: [],
              ShowSetting: true,
              active: false,
              description: 'Email',
              disable: false,
              group: false,
              icon: '',
              list: [],
              no: 2,
              text: 'Toolbar.email',
              to: '/upload-email'
            },
            {
              RoleAccess: [],
              ShowSetting: true,
              active: false,
              description: 'Cookies',
              disable: false,
              group: false,
              icon: '',
              list: [],
              no: 3,
              text: 'Toolbar.cookies',
              to: '/cookies-index'
            },
            {
              RoleAccess: [],
              ShowSetting: true,
              active: false,
              description: 'Upload',
              disable: false,
              group: false,
              icon: '',
              list: [],
              no: 5,
              text: 'Upload',
              to: '/upload-index'
            }
          ],
          no: 5,
          text: 'Toolbar.rconsent',
          to: '/send-consent'
        },
        {
          RoleAccess: [],
          ShowSetting: true,
          active: false,
          description: 'แจ้งประกาศ',
          disable: false,
          group: true,
          icon: '',
          list: [
            {
              RoleAccess: [],
              ShowSetting: true,
              active: false,
              description: 'OnePlatform',
              disable: false,
              group: false,
              icon: '',
              list: [],
              no: 1,
              text: 'OnePlatform',
              to: '/announce-oneplatform-index'
            }
          ],
          no: 6,
          text: 'Toolbar.announce',
          to: '/send-announce'
        },
        {
          RoleAccess: [],
          ShowSetting: true,
          active: false,
          description: 'ตั้งค่าอีเมล',
          disable: false,
          group: true,
          icon: '',
          list: [
            {
              RoleAccess: [],
              ShowSetting: true,
              active: false,
              children: [],
              description: 'ตั้งค่า SMTP อีเมล',
              disable: false,
              group: false,
              icon: '',
              no: 1,
              text: 'Toolbar.smtp',
              to: '/email-smtp-index'
            },
            {
              RoleAccess: [],
              ShowSetting: true,
              active: false,
              children: [],
              description: 'ตั้งค่า Template อีเมล',
              disable: false,
              group: false,
              icon: '',
              no: 2,
              text: 'Toolbar.tem',
              to: '/email-template-index'
            }
          ],
          no: 7,
          text: 'Toolbar.emailseting',
          to: '/config-email'
        }
      ],
      description: 'ผู้ดูแลระบบ',
      disable: false,
      group: true,
      icon: 'mdi-account-cog',
      no: 2,
      text: 'Toolbar.admin',
      to: '/administrator'
    }
  ]
}

const getters = {
  DataUpdateBot: (state) => state.DataUpdateBot,
  RefreshToken: (state) => state.RefreshToken,
  AccessToken: (state) => state.AccessToken,
  Authen: (state) => state.Authen,
  StatusBusiness: (state) => state.StatusBusiness,
  Profile: (state) => state.Profile,
  Business: (state) => state.Business,
  DataBotOnePlatform: (state) => state.DataBotOnePlatform,
  AllBusiness: (state) => state.AllBusiness,
  DataPolicy: (state) => state.DataPolicy,
  DataPetition: (state) => state.DataPetition,
  DataConsent: (state) => state.DataConsent,
  DataConsentId: (state) => state.DataConsentId,
  DataSmtpEmail: (state) => state.DataSmtpEmail,
  DataConsentGroup: (state) => state.DataConsentGroup,
  DataGeneralConsent: (state) => state.DataGeneralConsent,
  DataGroupConsent: (state) => state.DataGroupConsent,
  DataGroupConsentOnechat: (state) => state.DataGroupConsentOnechat,
  DataGroupConsentOnechatPath: (state) => state.DataGroupConsentOnechatPath,
  DataGeneralDashboard: (state) => state.DataGeneralDashboard,
  DataGroupDashboard: (state) => state.DataGroupDashboard,
  DataCheckRole: (state) => state.DataCheckRole,
  DataGroupOneChatSearch: (state) => state.DataGroupOneChatSearch,
  DataCheckUser: (state) => state.DataCheckUser,
  RoleAccount: (state) => state.RoleAccount,
  DataAccount: (state) => state.DataAccount,
  MenuToolbar: (state) => state.MenuToolbar,
  DataAllRoleAccess: (state) => state.DataAllRoleAccess,
  MenuToolbarDefault: (state) => state.MenuToolbarDefault,
  DataAnnounce: (state) => state.DataAnnounce,
  LoadingLogin: state => state.LoadingLogin
}

export default new Vuex.Store({
  state,
  actions,
  mutations,
  getters
})
